// subscriptionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../../utils/getAuthToken";

const BASE_URL = process.env.REACT_APP_SERVER_DOMAIN || 'http://localhost:8000';

// Fetches the current account's plan/feature data (used to gate nav items on
// plan-disabled features, e.g. AI Assistants) from /api/subscriptions/me.
export const fetchSubscriptionFeatures = createAsyncThunk(
  "subscription/fetchSubscriptionFeatures",
  async (_, { rejectWithValue }) => {
    const token = await getAuthToken();
    if (!token) {
      return rejectWithValue("No token found");
    }

    try {
      const response = await axios.get(`${BASE_URL}/api/subscriptions/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  planCode: null,
  subscription: null,
  features: [], // [{ key, label, limit, enabled, used, percentage }]
  loading: false,
  error: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionFeatures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionFeatures.fulfilled, (state, action) => {
        state.loading = false;
        state.planCode = action.payload?.planCode ?? state.planCode;
        state.subscription = action.payload?.subscription ?? null;
        state.features = action.payload?.features ?? [];
      })
      .addCase(fetchSubscriptionFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default subscriptionSlice.reducer;
